import { Controller } from "@hotwired/stimulus"

const STYLE_ID = "debug-outline-style"

// Connects to data-controller="debug"
export default class extends Controller {
  connect () {
    // 各要素の高さを取得（見つからなければ 0）
    const headerHeight  = document.querySelector("header")?.offsetHeight  ?? 0
    const footerHeight  = document.querySelector("footer")?.offsetHeight  ?? 0
    const elementHeight = this.element.offsetHeight

    const uiHeight = headerHeight + footerHeight - elementHeight

    const rootStyle = document.documentElement.style
    rootStyle.setProperty("--ui-height",  `${uiHeight}px`)
  }

  toggle() {
    const existing = document.getElementById(STYLE_ID)
    if (existing) {
      existing.remove()
    } else {
      const style = document.createElement("style")
      style.id = STYLE_ID
      style.textContent = "div { outline: 1px solid rgb(251, 189, 189); }"
      document.head.appendChild(style)
    }
  }
}
